import { createDraftSafeSelector } from '@reduxjs/toolkit';

import { IPaymentState, IPaymentItem, IPaymentTransactionItem, IWidgetSettings, IWidgetLanguage } from './interface';
import { ERequestStatus } from 'src/api/enumRequest';
import { ECryptoAddressTagType } from 'src/type';

import Icon from 'src/components/icon';

const paymentState = (state: any) => state.payment;

export const selectPayment: (state: any) => IPaymentItem | null = createDraftSafeSelector(
  paymentState,
  (state: IPaymentState) => state.getPayment.payment
);

export const selectOptionsCryptoCurrencies: (state: any) => { key: string; value: string }[] | undefined =
  createDraftSafeSelector(paymentState, (state: IPaymentState) =>
    state.getPayment.payment?.currency_settings
      .filter((currency: any) => currency.enabled && currency.type === 'Crypto')
      .map((currency: any) => ({
        key: `${currency.currency_id} ${currency.network}`,
        value: `${currency.currency_id} ${currency.network}`,
      }))
  );

export const selectStatusGetPayment: (state: any) => ERequestStatus = createDraftSafeSelector(
  paymentState,
  (state: IPaymentState) => state.getPayment.status
);

export const selectErrorGetPayment: (state: any) => string = createDraftSafeSelector(
  paymentState,
  (state: IPaymentState) => state.getPayment.error
);

// ---

export const selectWidgetLanguages: (state: any) => IWidgetLanguage[] = createDraftSafeSelector(
  paymentState,
  (state: IPaymentState) => state.widgetLanguages
);

// ---

export const selectWidgetSettings: (state: any) => IWidgetSettings = createDraftSafeSelector(
  paymentState,
  (state: IPaymentState) => state.widgetSettings
);

// ---

export const selectPaymentTransactions: (state: any) => IPaymentTransactionItem[] = createDraftSafeSelector(
  paymentState,
  (state: IPaymentState) => [...state.getPaymentTransactions].reverse()
);

// ---

export const selectCreatedPaymentAddress: (state: any) => string = createDraftSafeSelector(
  paymentState,
  (state: IPaymentState) => state.createPaymentAddress.address
);

export const selectCreatedPaymentAddressCurrencyId: (state: any) => string = createDraftSafeSelector(
  paymentState,
  (state: IPaymentState) => state.createPaymentAddress.address_currency_id
);

export const selectCreatedPaymentAddressId: (state: any) => string = createDraftSafeSelector(
  paymentState,
  (state: IPaymentState) => state.createPaymentAddress.address_id
);

export const selectTagType: (state: any) => ECryptoAddressTagType | undefined = createDraftSafeSelector(
  paymentState,
  (state: IPaymentState) => state.createPaymentAddress.tag_type
);

export const selectTagValue: (state: any) => string | undefined = createDraftSafeSelector(
  paymentState,
  (state: IPaymentState) => state.createPaymentAddress.tag_value
);

export const selectStatusCreatePaymentAddress: (state: any) => ERequestStatus = createDraftSafeSelector(
  paymentState,
  (state: IPaymentState) => state.createPaymentAddress.status
);

export const selectErrorCreatePaymentAddress: (state: any) => string = createDraftSafeSelector(
  paymentState,
  (state: IPaymentState) => state.createPaymentAddress.error
);
